import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Fix: Hide the progress bar dock when menu is open
  useEffect(() => {
    const progressDock = document.querySelector('.nav-container');
    if (progressDock) {
      if (isOpen) {
        progressDock.style.opacity = "0";
        progressDock.style.pointerEvents = "none";
        progressDock.style.visibility = "hidden";
      } else {
        progressDock.style.opacity = "1";
        progressDock.style.pointerEvents = "auto";
        progressDock.style.visibility = "visible";
      }
    }
  }, [isOpen]);

  return (
    <>
      <nav className="w-full py-2 z-40 relative">
        <div className="sm:w-11/12 mx-auto px-4 sm:px-0">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <Link to="/">
                <img
                  src="/Vector.png"
                  alt="Bluekite logo"
                  className="h-8 w-auto cursor-pointer"
                />
              </Link>
            </div>

            {/* Desktop nav links */}
            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/work"
                className="bg-[#d8d8f0] text-gray-700 text-sm font-medium px-5 py-2 rounded-full hover:bg-[#c0c0e8] transition-colors"
              >
                Work
              </Link>
              <Link
                to="/services"
                className="bg-[#d8d8f0] text-gray-700 text-sm font-medium px-5 py-2 rounded-full hover:bg-[#c0c0e8] transition-colors"
              >
                Services
              </Link>
              <Link
                to="/contact"
                className="bg-[#4F4FE8] text-white text-sm font-medium px-6 py-2 rounded-full hover:bg-[#3a3ad4] transition-colors"
              >
                Book a Call
              </Link>
            </div>

            {/* Mobile: Menu button */}
            <div className="flex md:hidden">
              <button
                onClick={() => setIsOpen(true)}
                className="bg-[#4F4FE8] text-white text-base font-medium px-7 py-3 rounded-2xl hover:bg-[#3a3ad4] transition-colors"
              >
                Menu
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Full-screen mobile menu overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex flex-col px-6 py-8 md:hidden overflow-y-auto"
          style={{
            background:
              "linear-gradient(160deg, #b8b8f0 0%, #c8a8e8 40%, #d0b0f0 70%, #c8c0f0 100%)",
          }}
        >
          {/* Top bar */}
          <div className="flex items-center justify-between mb-10">
            <div className="flex items-center gap-3">
              <Link to="/">
              <img
                src="/Vector.png"
                alt="Bluekite logo"
                onClick={() => setIsOpen(false)}
                className="h-8 w-auto brightness-0 invert"
              />
              </Link>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="bg-[#4F4FE8] text-white text-base font-medium px-7 py-3 rounded-2xl hover:bg-[#3a3ad4] transition-colors"
            >
              Close
            </button>
          </div>

          {/* Nav links */}
          <div className="flex flex-col gap-3 mb-10">
            <Link
              to="/work"
              onClick={() => setIsOpen(false)}
              className="border border-white text-white text-lg font-medium px-6 py-3 rounded-full w-fit hover:bg-white/20 transition-colors"
            >
              Work
            </Link>
            <Link
              to="/services"
              onClick={() => setIsOpen(false)}
              className="border border-white text-white text-lg font-medium px-6 py-3 rounded-full w-fit hover:bg-white/20 transition-colors"
            >
              Services
            </Link>
          </div>

          {/* Contact Us */}
          <h1 className="text-white text-5xl leading-tight mb-4">
            Contact Us
          </h1>
          <hr className="border-white/40 mb-6" />

          {/* Email */}
          <div className="mb-6">
            <h3 className="text-white font-bold text-lg mb-1">Email Us</h3>
            <a href="mailto:info.bluekite@gmail.com"
              className="text-white/80 text-sm"
            >
              info.bluekite@gmail.com
            </a>
          </div>

          {/* Connect */}
          <div className="mb-6">
            <h3 className="text-white font-bold text-lg mb-2">Connect</h3>
            <div className="flex flex-col gap-1">
              {["LinkedIn", "Twitter(X)", "Instagram", "TikTok"].map((s) => (
                <a key={s}
                  href="/"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* Location */}
          <div className="mb-10">
            <h3 className="text-white font-bold text-lg mb-2">Location</h3>
            <p className="text-white/80 text-sm">Aba, Abia State.</p>
            <p className="text-white/80 text-sm">Nigeria</p>
          </div>

          {/* Footer */}
          <div>
            <hr className="border-white/30 mb-4" />
            <p className="text-white/70 text-xs">
              ©Bluekite Consults Branding 
              <br/> & Public Relation Agency
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;